var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VueDateFilter',{attrs:{"default-filter":"today"},on:{"dateFilterChange":_vm.filter}}),_vm._v(" "),(!_vm.loading)?_c('div',{staticStyle:{"padding":"25px"}},[_c('LineChart',{attrs:{"labels":_vm.labels,"datasets":_vm.datasets}})],1):_c('div',{staticClass:"loader",attrs:{"id":"loader-1"}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e354829","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/admin-panel/components/widgets/VisitGraphWidget/VisitGraphWidget.vue
// module id = Urpe
// module chunks = 0